module.exports = __webpack_public_path__ + "static/b2b_mobile_header-2e19136ad1bf6e0667439932c71dc621.png";